<template>
  <v-card title="Szállás igények">
    <template v-slot:text>
      <v-row dense>
        <v-col cols="12" sm="8">
          <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="statusFilter"
            :items="statusOptions"
            label="Státusz"
            variant="outlined"
            hide-details
            clearable
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :sort-by="[{ key: 'from', order: 'desc' }]"
      :search="normalizedSearch"
    >
      <template v-slot:[`item.publicReference`]="{ item }">
        <span style="font-family: monospace">
          {{ formatPublicReference(item.publicReference) }}
        </span>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-chip
          color="blue"
          text="Részletek"
          @click="() => handleViewClick(item.id)"
        >
        </v-chip>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ inquiryStatusLabel(item.status) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref, toRefs } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { formatPublicReference } from "@/utils/formatReference";
import {
  inquiryStatusLabel,
  INQUIRY_STATUS_LABELS,
} from "@/utils/statusLabels";

export default defineComponent({
  name: "AdminAccommodationInquiries",
  props: {
    accommodationInquiries: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute();
    const search = ref("");
    const normalizedSearch = computed(() => search.value.replace(/-/g, ""));
    const statusFilter = ref<string | null>(
      (route.query.status as string) || null
    );
    const { accommodationInquiries: propAccommodationInquiries } =
      toRefs(props);

    const statusOptions = Object.entries(INQUIRY_STATUS_LABELS).map(
      ([value, title]) => ({ title, value })
    );

    const filteredItems = computed(() => {
      if (!statusFilter.value) return propAccommodationInquiries.value;
      return propAccommodationInquiries.value.filter(
        (i) => i.status === statusFilter.value
      );
    });

    const headers = ref([
      { title: "Referencia", value: "publicReference", sortable: false },
      { title: "Felhasználó", value: "userName", sortable: true },
      { title: "Helység", value: "area", sortable: true },
      { title: "Költséghely", value: "costCenterName", sortable: true },
      { title: "Érkezés", value: "from", sortable: true },
      { title: "Távozás", value: "to", sortable: true },
      { title: "Létszám", value: "numberOfPeople", sortable: true },
      { title: "Státusz", value: "status", sortable: true },
      { title: "Részletek", value: "id", sortable: true },
    ]);

    return {
      headers,
      // eslint-disable-next-line vue/no-dupe-keys
      accommodationInquiries: propAccommodationInquiries,
      handleViewClick: (id: number) => {
        console.log(id);
        router.push("/inquiry/details/" + id);
      },
      search: search,
      normalizedSearch,
      statusFilter,
      statusOptions,
      filteredItems,
      formatPublicReference,
      inquiryStatusLabel,
    };
  },
});
</script>

<style scoped></style>
